import { VISIBILITY_CHANGE } from './polyfill';


/**
 * 用visibility change的方法检测app是否拉起
 *
 * @returns 拉起是否成功
 *
 */
export function checkIfOpen(timeout?: number): Promise<boolean>;
/**
 * 使用回调函数的方式
 *
 * @param callback - 回调函数
 *
 */
export function checkIfOpen(callback: (isSuccess: boolean) => unknown, timeout?: number): void;
export function checkIfOpen(argA?: number | ((isSuccess: boolean) => unknown), argB?: number): Promise<boolean> | void {
  const check = (timeout: number, caller: (isSuccess: boolean) => unknown) => {
    const timer = setTimeout(() => {
      caller(false);
      document.removeEventListener(VISIBILITY_CHANGE, eventListener);
      window.removeEventListener('pagehide', eventListener);
    }, timeout);

    const eventListener = () => {
      caller(true);
      clearTimeout(timer);
    };


    if (typeof VISIBILITY_CHANGE !== 'undefined') {
      document.addEventListener(VISIBILITY_CHANGE, eventListener, { once: true });
    } else {
      window.addEventListener('pagehide', eventListener, { once: true });
    }
  };
  if (typeof argA === 'number' || typeof argA === 'undefined') {
    const timeout = argA ?? 3000;
    return new Promise<boolean>((resolve) => {
      check(timeout, resolve);
    });
  }
  if (typeof argA === 'function') {
    const timeout = argB ?? 3000;
    const callback = argA;
    check(timeout, callback);
  }
}
